import "packages/frontend/core/src/modules/streamlain/sidebar/elster-fullscreen-view.css.ts.vanilla.css!=!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/modules/streamlain/sidebar/elster-fullscreen-view.css.ts.vanilla.css\",\"source\":\"#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\"}!../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var actionBar = '_1vqsnlq1p';
export var actionBarLeft = '_1vqsnlq1q';
export var actionBarRight = '_1vqsnlq1s';
export var actionBarZahllast = '_1vqsnlq1r';
export var addPeriodButton = '_1vqsnlqq';
export var configField = '_1vqsnlqu';
export var configLabel = '_1vqsnlqv';
export var configRow = '_1vqsnlqt';
export var configValue = '_1vqsnlqw';
export var confirmActions = '_1vqsnlq2p';
export var confirmBody = '_1vqsnlq2l';
export var confirmCheckboxRow = '_1vqsnlq2o';
export var confirmDialog = '_1vqsnlq2j';
export var confirmOverlay = '_1vqsnlq2i';
export var confirmSummary = '_1vqsnlq2m';
export var confirmSummaryRow = '_1vqsnlq2n';
export var confirmTitle = '_1vqsnlq2k';
export var container = '_1vqsnlq0';
export var contentArea = '_1vqsnlqc';
export var dashboard = '_1vqsnlqe';
export var dashboardGrid = '_1vqsnlqg';
export var dashboardTitle = '_1vqsnlqf';
export var emptyState = '_1vqsnlq2q';
export var fieldGroup = '_1vqsnlq12';
export var fieldGroupColumnHeaders = '_1vqsnlq15';
export var fieldGroupColumnHeadersSingle = '_1vqsnlq16';
export var fieldGroupTable = '_1vqsnlq14';
export var fieldGroupTitle = '_1vqsnlq13';
export var formHeader = '_1vqsnlqr';
export var formTitle = '_1vqsnlqs';
export var historyCorrectionBadge = '_1vqsnlq2e';
export var historyDetailCell = '_1vqsnlq29';
export var historyDetailGrid = '_1vqsnlq2a';
export var historyDetailItem = '_1vqsnlq2b';
export var historyDetailLabel = '_1vqsnlq2c';
export var historyDetailRow = '_1vqsnlq28';
export var historyDetailValue = '_1vqsnlq2d';
export var historyExpandIcon = '_1vqsnlq2g';
export var historyExpandIconOpen = '_1vqsnlq2h';
export var historyMetaRow = '_1vqsnlq2f';
export var historyRow = '_1vqsnlq26';
export var historyRowExpanded = '_1vqsnlq27';
export var historySection = '_1vqsnlq21';
export var historySectionTitle = '_1vqsnlq22';
export var historyTable = '_1vqsnlq23';
export var historyTd = '_1vqsnlq25';
export var historyTh = '_1vqsnlq24';
export var kzBadge = '_1vqsnlq1f';
export var kzCheckbox = '_1vqsnlq1g';
export var kzFieldError = '_1vqsnlq1h';
export var kzInput = '_1vqsnlq1c';
export var kzInputError = '_1vqsnlq1e';
export var kzInputReadonly = '_1vqsnlq1d _1vqsnlq1c';
export var kzInputWrapper = '_1vqsnlq1b';
export var kzLabel = '_1vqsnlq1a';
export var kzRow = '_1vqsnlq17';
export var kzRowSingle = '_1vqsnlq18';
export var kzZeile = '_1vqsnlq19';
export var mainLayout = '_1vqsnlq4';
export var migrationActions = '_1vqsnlq35';
export var migrationBanner = '_1vqsnlq36';
export var migrationBannerText = '_1vqsnlq37';
export var migrationBody = '_1vqsnlq2w';
export var migrationDialog = '_1vqsnlq2t';
export var migrationFieldBadgeAdded = '_1vqsnlq30';
export var migrationFieldBadgeRemoved = '_1vqsnlq31';
export var migrationFieldHeader = '_1vqsnlq2z';
export var migrationFieldItem = '_1vqsnlq2y';
export var migrationFieldLabel = '_1vqsnlq32';
export var migrationFieldList = '_1vqsnlq2x';
export var migrationFieldType = '_1vqsnlq33';
export var migrationInfo = '_1vqsnlq34';
export var migrationOverlay = '_1vqsnlq2s';
export var migrationTitle = '_1vqsnlq2u';
export var migrationVersionBadge = '_1vqsnlq2v';
export var periodCard = '_1vqsnlqh';
export var periodCardActive = '_1vqsnlqi';
export var periodCardMeta = '_1vqsnlqk';
export var periodCardTitle = '_1vqsnlqj';
export var plausibilityWarning = '_1vqsnlq20';
export var readOnlyBanner = '_1vqsnlq2r';
export var scrollArea = '_1vqsnlqd';
export var sectionBlock = '_1vqsnlqx';
export var sectionHeader = '_1vqsnlqy';
export var sectionNumber = '_1vqsnlqz';
export var sectionTitle = '_1vqsnlq10';
export var sectionTooltipIcon = '_1vqsnlq11';
export var sidebarCheckmark = '_1vqsnlqa';
export var sidebarHeader = '_1vqsnlq6';
export var sidebarItem = '_1vqsnlq8';
export var sidebarItemActive = '_1vqsnlq9';
export var sidebarNav = '_1vqsnlq5';
export var sidebarNumber = '_1vqsnlqb';
export var sidebarSubheader = '_1vqsnlq7';
export var statusBadge = '_1vqsnlql';
export var statusDraft = '_1vqsnlqm _1vqsnlql';
export var statusError = '_1vqsnlqp _1vqsnlql';
export var statusSent = '_1vqsnlqo _1vqsnlql';
export var statusValid = '_1vqsnlqn _1vqsnlql';
export var summaryLabel = '_1vqsnlq1m';
export var summaryRow = '_1vqsnlq1l';
export var summarySection = '_1vqsnlq1k';
export var summaryTotal = '_1vqsnlq1o';
export var summaryValue = '_1vqsnlq1n';
export var tab = '_1vqsnlq2';
export var tabActive = '_1vqsnlq3';
export var tabBar = '_1vqsnlq1';
export var testModeBadge = '_1vqsnlq1t';
export var tooltipContainer = '_1vqsnlq1i';
export var tooltipIcon = '_1vqsnlq1j';
export var validationError = '_1vqsnlq1w _1vqsnlq1u';
export var validationErrorItem = '_1vqsnlq1z';
export var validationErrorSummary = '_1vqsnlq1x';
export var validationErrorTitle = '_1vqsnlq1y';
export var validationFeedback = '_1vqsnlq1u';
export var validationSuccess = '_1vqsnlq1v _1vqsnlq1u';